import "packages/frontend/core/src/modules/streamlain/sidebar/elster-fullscreen-view.css.ts.vanilla.css!=!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/modules/streamlain/sidebar/elster-fullscreen-view.css.ts.vanilla.css\",\"source\":\"#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\"}!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var actionBar = '_1vqsnlq1p';
export var actionBarLeft = '_1vqsnlq1q';
export var actionBarRight = '_1vqsnlq1s';
export var actionBarZahllast = '_1vqsnlq1r';
export var addPeriodButton = '_1vqsnlqq';
export var configField = '_1vqsnlqu';
export var configLabel = '_1vqsnlqv';
export var configRow = '_1vqsnlqt';
export var configValue = '_1vqsnlqw';
export var confirmActions = '_1vqsnlq2p';
export var confirmBody = '_1vqsnlq2l';
export var confirmCheckboxRow = '_1vqsnlq2o';
export var confirmDialog = '_1vqsnlq2j';
export var confirmOverlay = '_1vqsnlq2i';
export var confirmSummary = '_1vqsnlq2m';
export var confirmSummaryRow = '_1vqsnlq2n';
export var confirmTitle = '_1vqsnlq2k';
export var container = '_1vqsnlq0';
export var contentArea = '_1vqsnlqc';
export var dashboard = '_1vqsnlqe';
export var dashboardGrid = '_1vqsnlqg';
export var dashboardTitle = '_1vqsnlqf';
export var emptyState = '_1vqsnlq2q';
export var fieldGroup = '_1vqsnlq12';
export var fieldGroupColumnHeaders = '_1vqsnlq15';
export var fieldGroupColumnHeadersSingle = '_1vqsnlq16';
export var fieldGroupTable = '_1vqsnlq14';
export var fieldGroupTitle = '_1vqsnlq13';
export var formHeader = '_1vqsnlqr';
export var formTitle = '_1vqsnlqs';
export var historyCorrectionBadge = '_1vqsnlq2e';
export var historyDetailCell = '_1vqsnlq29';
export var historyDetailGrid = '_1vqsnlq2a';
export var historyDetailItem = '_1vqsnlq2b';
export var historyDetailLabel = '_1vqsnlq2c';
export var historyDetailRow = '_1vqsnlq28';
export var historyDetailValue = '_1vqsnlq2d';
export var historyExpandIcon = '_1vqsnlq2g';
export var historyExpandIconOpen = '_1vqsnlq2h';
export var historyMetaRow = '_1vqsnlq2f';
export var historyRow = '_1vqsnlq26';
export var historyRowExpanded = '_1vqsnlq27';
export var historySection = '_1vqsnlq21';
export var historySectionTitle = '_1vqsnlq22';
export var historyTable = '_1vqsnlq23';
export var historyTd = '_1vqsnlq25';
export var historyTh = '_1vqsnlq24';
export var kzBadge = '_1vqsnlq1f';
export var kzCheckbox = '_1vqsnlq1g';
export var kzFieldError = '_1vqsnlq1h';
export var kzInput = '_1vqsnlq1c';
export var kzInputError = '_1vqsnlq1e';
export var kzInputReadonly = '_1vqsnlq1d _1vqsnlq1c';
export var kzInputWrapper = '_1vqsnlq1b';
export var kzLabel = '_1vqsnlq1a';
export var kzRow = '_1vqsnlq17';
export var kzRowSingle = '_1vqsnlq18';
export var kzZeile = '_1vqsnlq19';
export var mainLayout = '_1vqsnlq4';
export var migrationActions = '_1vqsnlq35';
export var migrationBanner = '_1vqsnlq36';
export var migrationBannerText = '_1vqsnlq37';
export var migrationBody = '_1vqsnlq2w';
export var migrationDialog = '_1vqsnlq2t';
export var migrationFieldBadgeAdded = '_1vqsnlq30';
export var migrationFieldBadgeRemoved = '_1vqsnlq31';
export var migrationFieldHeader = '_1vqsnlq2z';
export var migrationFieldItem = '_1vqsnlq2y';
export var migrationFieldLabel = '_1vqsnlq32';
export var migrationFieldList = '_1vqsnlq2x';
export var migrationFieldType = '_1vqsnlq33';
export var migrationInfo = '_1vqsnlq34';
export var migrationOverlay = '_1vqsnlq2s';
export var migrationTitle = '_1vqsnlq2u';
export var migrationVersionBadge = '_1vqsnlq2v';
export var periodCard = '_1vqsnlqh';
export var periodCardActive = '_1vqsnlqi';
export var periodCardMeta = '_1vqsnlqk';
export var periodCardTitle = '_1vqsnlqj';
export var plausibilityWarning = '_1vqsnlq20';
export var readOnlyBanner = '_1vqsnlq2r';
export var scrollArea = '_1vqsnlqd';
export var sectionBlock = '_1vqsnlqx';
export var sectionHeader = '_1vqsnlqy';
export var sectionNumber = '_1vqsnlqz';
export var sectionTitle = '_1vqsnlq10';
export var sectionTooltipIcon = '_1vqsnlq11';
export var sidebarCheckmark = '_1vqsnlqa';
export var sidebarHeader = '_1vqsnlq6';
export var sidebarItem = '_1vqsnlq8';
export var sidebarItemActive = '_1vqsnlq9';
export var sidebarNav = '_1vqsnlq5';
export var sidebarNumber = '_1vqsnlqb';
export var sidebarSubheader = '_1vqsnlq7';
export var statusBadge = '_1vqsnlql';
export var statusDraft = '_1vqsnlqm _1vqsnlql';
export var statusError = '_1vqsnlqp _1vqsnlql';
export var statusSent = '_1vqsnlqo _1vqsnlql';
export var statusValid = '_1vqsnlqn _1vqsnlql';
export var summaryLabel = '_1vqsnlq1m';
export var summaryRow = '_1vqsnlq1l';
export var summarySection = '_1vqsnlq1k';
export var summaryTotal = '_1vqsnlq1o';
export var summaryValue = '_1vqsnlq1n';
export var tab = '_1vqsnlq2';
export var tabActive = '_1vqsnlq3';
export var tabBar = '_1vqsnlq1';
export var testModeBadge = '_1vqsnlq1t';
export var tooltipContainer = '_1vqsnlq1i';
export var tooltipIcon = '_1vqsnlq1j';
export var validationError = '_1vqsnlq1w _1vqsnlq1u';
export var validationErrorItem = '_1vqsnlq1z';
export var validationErrorSummary = '_1vqsnlq1x';
export var validationErrorTitle = '_1vqsnlq1y';
export var validationFeedback = '_1vqsnlq1u';
export var validationSuccess = '_1vqsnlq1v _1vqsnlq1u';